module.exports={author:"Kelly Schirmann",date:"09/19/2022",publishDate:"09/19/2022",highlighted:!1,badge:"",tags:"",title:"Here on Earth"};